import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "material-icons/iconfont/material-icons.css";
import { BrowserRouter } from "react-router-dom";
import mainReducer from "./Redux/MainReducer";
import { combineReducers } from "redux";
import { createStore } from "redux";
import { Provider } from "react-redux";
import FusionCharts from "fusioncharts";

const rootReducer = combineReducers({
  mainReducer,
});

const store = createStore(rootReducer);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);
const config = require("../src/config/keys");

FusionCharts.options.license({
  key: config().license,

  creditLabel: false,
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
